import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

import { capitalize } from "vue";
import meeting from "@/assets/icons/chineseCalendar/meeting.svg";
import earthworks from "@/assets/icons/chineseCalendar/earthworks.svg";
import removalOfUnnecessary from "@/assets/icons/chineseCalendar/removal_of_unnecessary.svg";
import investment from "@/assets/icons/chineseCalendar/investment.svg";
import startDiet from "@/assets/icons/chineseCalendar/start_diet.svg";
import startTreatment from "@/assets/icons/chineseCalendar/start_treatment.svg";
import startNewProject from "@/assets/icons/chineseCalendar/start_new_project.svg";
import startLearning from "@/assets/icons/chineseCalendar/start_learning.svg";
import startWork from "@/assets/icons/chineseCalendar/start_work.svg";
import startConstruction from "@/assets/icons/chineseCalendar/start_construction.svg";
import housewarming from "@/assets/icons/chineseCalendar/housewarming.svg";
import rest from "@/assets/icons/chineseCalendar/rest.svg";
import businessOpening from "@/assets/icons/chineseCalendar/business_opening.svg";
import relocation from "@/assets/icons/chineseCalendar/relocation.svg";
import planning from "@/assets/icons/chineseCalendar/planning.svg";
import signingDocuments from "@/assets/icons/chineseCalendar/signing_documents.svg";
import seekingMedicalHelp from "@/assets/icons/chineseCalendar/seeking_medical_help.svg";
import jobSearch from "@/assets/icons/chineseCalendar/job_search.svg";
import propertyPurchase from "@/assets/icons/chineseCalendar/property_purchase.svg";
import receivingRewards from "@/assets/icons/chineseCalendar/receiving_rewards.svg";
import funeral from "@/assets/icons/chineseCalendar/funeral.svg";
import travel from "@/assets/icons/chineseCalendar/travel.svg";
import divorce from "@/assets/icons/chineseCalendar/divorce.svg";
import renovation from "@/assets/icons/chineseCalendar/renovation.svg";
import debtCollection from "@/assets/icons/chineseCalendar/debt_collection.svg";
import wedding from "@/assets/icons/chineseCalendar/wedding.svg";
import date from "@/assets/icons/chineseCalendar/date.svg";
import cleaning from "@/assets/icons/chineseCalendar/cleaning.svg";
import foundationLaying from "@/assets/icons/chineseCalendar/foundation_laying.svg";
import loanRequest from "@/assets/icons/chineseCalendar/loan_request.svg";
import bedRelocation from "@/assets/icons/chineseCalendar/bed_relocation.svg";
import propertyDivision from "@/assets/icons/chineseCalendar/property_division.svg";
import demolitionOfOldBuildings from "@/assets/icons/chineseCalendar/demolition_of_old_buildings.svg";
import legalMatters from "@/assets/icons/chineseCalendar/legal_matters.svg";
import AppTooltip from "@/components/AppTooltip.vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChineseIcon',
  props: {
    name: {}
  },
  setup(__props: any) {

const icons: Record<string, string> = {
  meetings: meeting,
  earthworks: earthworks,
  decluttering: removalOfUnnecessary,
  investments: investment,
  start_diet: startDiet,
  start_treatment: startTreatment,
  start_new_project: startNewProject,
  start_learning: startLearning,
  start_work: startWork,
  start_construction: startConstruction,
  housewarming: housewarming,
  rest: rest,
  start_business: businessOpening,
  relocation: relocation,
  planning: planning,
  signing_documents: signingDocuments,
  seeking_medical_help: seekingMedicalHelp,
  job_search: jobSearch,
  property_purchase: propertyPurchase,
  receiving_awards: receivingRewards,
  funeral: funeral,
  travel: travel,
  divorce: divorce,
  renovation: renovation,
  debt_collection: debtCollection,
  wedding: wedding,
  date: date,
  cleaning: cleaning,
  foundation_laying: foundationLaying,
  apply_for_credit: loanRequest,
  bed_repositioning: bedRelocation,
  property_division: propertyDivision,
  demolition: demolitionOfOldBuildings,
  legal_matters: legalMatters,
};



const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppTooltip, null, {
    trigger: _withCtx(() => [
      _createElementVNode("img", {
        src: icons[__props.name],
        alt: "icon",
        class: "w-5 h-5"
      }, null, 8, _hoisted_1)
    ]),
    popper: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(capitalize(_unref(t)(`calculators.chinese-calendar.doing.${__props.name}`))), 1)
    ]),
    _: 1
  }))
}
}

})